/* JCKED buy box. Prices come from Shopify's own selling_plan_allocations (per variant), so the total shown
   always equals what the cart will charge. Cart submission is handled by Dawn's <product-form> (product-form.js),
   so the cart drawer / cart count keep updating through the section rendering API. */
(function () {
  if (customElements.get('jx-pdp')) return;

  function scrollToBuyBox(root) {
    if (!root) return;
    var target = root.querySelector('[data-jxa-box]') || root.querySelector('.jx-pdp__buy') || root;
    var header = document.querySelector('[data-jh-sticky]');
    var offset = (header ? header.getBoundingClientRect().height : 0) + 16;
    var top = Math.max(0, target.getBoundingClientRect().top + window.scrollY - offset);
    var behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    window.scrollTo({ top: top, behavior: behavior });
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  }


  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    function withDelimiter(n, thousands, decimal) {
      var whole = n.replace(/\B(?=(\d{3})+(?!\d))/g, thousands || ',');
      return whole;
    }
    var f = format || '${{amount}}';
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount': return withDelimiter(parts[0], ',') + '.' + parts[1];
        case 'amount_no_decimals': return withDelimiter(parts[0], ',');
        case 'amount_with_comma_separator': return withDelimiter(parts[0], '.') + ',' + parts[1];
        case 'amount_no_decimals_with_comma_separator': return withDelimiter(parts[0], '.');
        case 'amount_with_apostrophe_separator': return withDelimiter(parts[0], "'") + '.' + parts[1];
        default: return withDelimiter(parts[0], ',') + '.' + parts[1];
      }
    });
  }

  /* Currency converter app (Bucks): prices written here are in the store currency, so ask it to convert them again,
     or a converted page shows two currencies after a tier click. Batched to one call per frame. */
  var reconvertQueued = false, reconvertTries = 0;
  function reconvertCurrency() {
    if (reconvertQueued) return;
    var ready = window.bucksCC && typeof window.bucksCC.reConvert === 'function';
    if (!ready) { /* first paint can beat the app's script: try again for a few seconds */
      if (reconvertTries++ < 20) { reconvertQueued = true; setTimeout(function () { reconvertQueued = false; reconvertCurrency(); }, 500); }
      return;
    }
    reconvertQueued = true;
    requestAnimationFrame(function () {
      reconvertQueued = false;
      try { window.bucksCC.reConvert(); } catch (e) {}
    });
  }

  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  class JxPdp extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      var dataEl = this.querySelector('[data-jx-pdp-data]');
      if (!dataEl) return;
      try { this.data = JSON.parse(dataEl.textContent); } catch (e) { return; }

      this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
      this.form = this.querySelector('form');
      this.idInput = this.querySelector('[data-jx-id]');
      this.planInput = this.querySelector('[data-jx-plan-input]');
      this.qtyInput = this.querySelector('[data-jx-qty-input]');
      this.submit = this.querySelector('[data-jx-submit]');
      this.submitLabel = this.querySelector('[data-jx-submit-label]');
      this.freqSelect = this.querySelector('[data-jx-freq-select]');
      this.sticky = this.querySelector('[data-jx-sticky]');
      this.track = this.querySelector('[data-jx-gal-track]');

      this.hasPlans = this.data.plans.length > 0;
      this.mode = this.planInput && !this.planInput.disabled ? 'sub' : 'once';
      var oneTime = this.querySelector('input[name="jx-purchase"][value="once"]');
      if (oneTime && oneTime.checked) this.mode = 'once';
      this.planId = this.planInput ? this.planInput.value : '';
      /* qty = PAID quantity of the chosen tier; free = bottles added on top ("Buy 2, Get 1 Free"). The cart gets qty + free. */
      var chosen = this.querySelector('input[name="jx-tier"]:checked');
      this.qty = chosen ? Number(chosen.value) || 1 : Number(this.qtyInput ? this.qtyInput.value : 1) || 1;
      this.free = chosen ? Number(chosen.closest('.jx-tier').dataset.free || 0) : 0;

      this.bundleOffset = 0;
      this._bundleKey = '';

      this.bind();
      this.bindGallery();
      this.bindSticky();
      this.render(true);
    }

    /* ---------- state helpers ---------- */
    activeTierFlavorPanel() {
      return this.querySelector('.jx-tier__flavors.is-open');
    }

    selectedOptions() {
      var panel = this.activeTierFlavorPanel();
      if (panel) {
        var select = panel.querySelector('[data-jx-tier-flavor-select]');
        return select ? [select.value] : [];
      }
      var values = [];
      this.querySelectorAll('[data-jx-option]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        values[Number(group.dataset.jxOption)] = checked ? checked.value : null;
      });
      return values;
    }

    currentVariant() {
      var sel = this.selectedOptions();
      var variants = this.data.variants;
      // Products with a single (default) variant or hidden single-value options.
      if (!sel.length) {
        var currentId = Number(this.idInput.value);
        return variants.find(function (v) { return v.id === currentId; }) || variants[0];
      }
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return sel[i] == null || sel[i] === o; });
      }) || null;
    }

    unit(variant) {
      if (this.mode === 'sub' && this.planId && variant.plans[this.planId] != null) return variant.plans[this.planId];
      return variant.price;
    }

    money(cents) { return formatMoney(cents, this.moneyFormat); }

    // Zero-dollar totals (free trials) read as text, not "$0.00".
    priceText(cents) { return cents === 0 ? esc(this.dataset.freeLabel || 'Free') : this.money(cents); }

    /* ---------- events ---------- */
    bind() {
      var self = this;
      this.addEventListener('submit', function (e) {
        if (e.target !== self.form || !self.activeTierFlavorPanel()) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        self.submitMulti();
      }, true);
      this.addEventListener('change', function (e) {
        var t = e.target;
        if (t.hasAttribute('data-jx-tier-flavor-select')) {
          self.render(false, true);
        } else if (t.closest('[data-jx-option]')) {
          var g = t.closest('[data-jx-option]').querySelector('[data-jx-option-value]');
          if (g) g.textContent = t.value;
          self.render(false, true);
        } else if (t.name === 'jx-purchase') {
          self.mode = t.value === 'once' ? 'once' : 'sub';
          self.render();
        } else if (t.name === 'jx-tier') {
          self.qty = Number(t.value) || 1;
          self.free = Number(t.closest('.jx-tier').dataset.free || 0);
          self.showTierFlavors(t.closest('[data-jx-tier-item]'));
          self.render();
        } else if (t === self.freqSelect) {
          self.planId = t.value;
          self.render();
        }
      });
    }

    /* Shows the flavor dropdowns nested in the chosen tier, hides every other tier's (animated, not display:none). */
    showTierFlavors(tierItem) {
      this.querySelectorAll('[data-jx-tier-item]').forEach(function (item) {
        var panel = item.querySelector('.jx-tier__flavors');
        if (!panel) return;
        var open = item === tierItem;
        panel.classList.toggle('is-open', open);
        panel.inert = !open;
      });
    }

    /* ---------- render ---------- */
    render(initial, variantChanged) {
      var variant = this.currentVariant();
      var sold = !variant || !variant.available;
      var hasPlanForVariant = variant && this.hasPlans && this.planId && variant.plans[this.planId] != null;
      if (this.mode === 'sub' && !hasPlanForVariant && !this.data.requiresPlan) this.mode = 'once';

      if (variant) {
        this.idInput.value = variant.id;
        if (variantChanged) this.syncUrl(variant.id);
        if (variantChanged) this.showMedia(variant.media);
      }

      // Selling plan input is only submitted for subscriptions.
      if (this.planInput) {
        var useSub = this.mode === 'sub' && hasPlanForVariant;
        this.planInput.disabled = !useSub;
        this.planInput.value = this.planId;
      }
      if (this.freqSelect) {
        this.freqSelect.closest('[data-jx-freq]').hidden = this.mode !== 'sub';
      }
      // Keep the disclosure aligned with the plan actually submitted, including one-time purchases.
      var useSubscriptionNotice = this.mode === 'sub' && hasPlanForVariant;
      this.querySelectorAll('[data-jx-subscription-notice]').forEach(function (notice) {
        notice.hidden = !useSubscriptionNotice;
      });
      var selectedPlan = this.data.plans.find(function (plan) { return String(plan.id) === String(this.planId); }, this);
      var planName = selectedPlan ? String(selectedPlan.name || '').toLowerCase().trim() : '';
      var cadence = 'on the schedule shown at checkout';
      if (planName.indexOf('every ') !== -1) cadence = 'every ' + planName.split('every ').pop().trim();
      else if (planName.indexOf('(4 weeks)') !== -1) cadence = 'every 4 weeks';
      else if (planName.indexOf('monthly') !== -1) cadence = 'every month';
      this.querySelectorAll('[data-jx-subscription-faq]').forEach(function (faq) {
        var question = faq.querySelector('.jxf__q-text');
        var answer = faq.querySelector('.jxf__a');
        if (!question || !answer) return;
        if (!faq._jxSubscriptionCopy) {
          faq._jxSubscriptionCopy = { question: question.textContent, answer: answer.innerHTML };
        }
        if (useSubscriptionNotice) {
          question.textContent = faq._jxSubscriptionCopy.question;
          answer.innerHTML = faq._jxSubscriptionCopy.answer;
        } else {
          question.textContent = 'Is this a subscription?';
          answer.textContent = 'This is a one-time purchase. Nothing renews.';
        }
      });
      this.querySelectorAll('[data-jx-subscription-cadence]').forEach(function (label) {
        label.textContent = cadence;
      });

      this.qtyInput.value = this.qty + (this.free || 0);
      this.updateBundleImage(initial);

      if (!variant) { this.setSubmit(true, esc(this.submit.dataset.soldoutLabel), null); return; }

      var unitNow = this.unit(variant);
      var oneTime = variant.price;
      var compareUnit = Math.max(variant.compare || 0, oneTime);

      // Subscribe chip: % saved vs one-time.
      var chip = this.querySelector('[data-jx-save-chip]');
      if (chip) {
        var subUnit = hasPlanForVariant ? variant.plans[this.planId] : oneTime;
        var pct = oneTime > 0 ? Math.round(((oneTime - subUnit) / oneTime) * 100) : 0;
        chip.hidden = pct <= 0;
        if (pct > 0) chip.textContent = subUnit === 0 ? (this.dataset.freeLabel || 'Free') : 'Save ' + pct + '%';
      }

      // Quantity tiers
      var self = this;
      this.querySelectorAll('.jx-tier').forEach(function (tier) {
        var q = Number(tier.dataset.qty);
        var freeQ = Number(tier.dataset.free || 0);
        var price = unitNow * q;
        var strike = compareUnit * (q + freeQ);
        tier.querySelector('[data-jx-tier-price]').innerHTML = self.priceText(price);
        var cmp = tier.querySelector('[data-jx-tier-compare]');
        var save = tier.querySelector('[data-jx-tier-save]');
        cmp.innerHTML = strike > price ? self.money(strike) : '';
        save.innerHTML = strike > price ? 'Save ' + self.money(strike - price) : '';
      });
      reconvertCurrency();

      // Gifts: earned by bottle count, one-time or subscription (same rule the cart applies in jx-gifts.js)
      this.querySelectorAll('.jx-gift').forEach(function (gift) {
        var min = Number(gift.dataset.unlock || 1);
        var unlocked = self.qty >= min;
        gift.classList.toggle('is-unlocked', unlocked);
        var st = gift.querySelector('.jx-gift__status');
        st.textContent = unlocked ? st.dataset.unlockedText : st.dataset.lockedText.replace('{n}', min);
      });

      // Option availability (strike sold-out values given the other selections)
      this.updateOptionAvailability();

      var total = unitNow * this.qty;
      this.setSubmit(sold, sold ? esc(this.submit.dataset.soldoutLabel) : esc(this.submit.dataset.addLabel) + ' \u2014 ' + this.priceText(total), total);
    }

    /* ---------- multi-flavor (2+ bottles): one dropdown per bottle, nested in the chosen tier ---------- */
    total() { return this.qty + (this.free || 0); }

    /* One cart line per distinct flavor chosen across the tier's dropdowns, quantities summed. */
    multiLines() {
      var self = this;
      var panel = this.activeTierFlavorPanel();
      if (!panel) return [];
      var tally = {};
      var order = [];
      panel.querySelectorAll('[data-jx-tier-flavor-select]').forEach(function (select) {
        var value = select.value;
        if (!(value in tally)) { tally[value] = 0; order.push(value); }
        tally[value] += 1;
      });
      return order.map(function (value) {
        var v = self.data.variants.find(function (x) { return x.options[0] === value; });
        return v ? { id: v.id, quantity: tally[value], plan: self.mode === 'sub' && self.planId && v.plans[self.planId] != null ? self.planId : null } : null;
      });
    }

    /* One cart line per flavor, added in a single request. Mirrors <product-form> (Dawn) so the drawer and count refresh the same way. */
    submitMulti() {
      var self = this;
      var pf = this.querySelector('product-form');
      var btn = this.submit;
      if (btn.getAttribute('aria-disabled') === 'true' || btn.disabled) return;
      var lines = this.multiLines();
      if (!lines.length || lines.some(function (l) { return !l; })) return;

      var showError = function (msg) { if (pf && typeof pf.handleErrorMessage === 'function') pf.handleErrorMessage(msg || false); };
      var spinner = pf && pf.querySelector('.loading__spinner');
      showError(false);
      btn.setAttribute('aria-disabled', true);
      btn.classList.add('loading');
      if (spinner) spinner.classList.remove('hidden');

      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      var fd = new FormData();
      lines.forEach(function (l, i) {
        fd.append('items[' + i + '][id]', l.id);
        fd.append('items[' + i + '][quantity]', l.quantity);
        if (l.plan) fd.append('items[' + i + '][selling_plan]', l.plan);
      });
      if (cart) {
        fd.append('sections', cart.getSectionsToRender().map(function (x) { return x.id; }));
        fd.append('sections_url', window.location.pathname);
        cart.setActiveElement(document.activeElement);
      }
      config.body = fd;

      var failed = false;
      fetch(routes.cart_add_url, config)
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) {
            failed = true;
            showError(res.description || res.message);
            publish(PUB_SUB_EVENTS.cartError, { source: 'product-form', productVariantId: lines[0].id, errors: res.errors || res.description, message: res.message });
            return;
          }
          if (!cart) { window.location.reload(); return; }
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: lines[0].id, cartData: res });
          cart.renderContents(res);
        })
        .catch(function (e) { failed = true; console.error(e); })
        .finally(function () {
          btn.classList.remove('loading');
          if (cart && cart.classList && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          btn.removeAttribute('aria-disabled');
          if (spinner) spinner.classList.add('hidden');
        });
    }

    /* ---------- bundle image ---------- */
    /* Each Quantity tier can carry its own image (everything the customer gets). It leads the gallery while that tier is chosen.
       Picking another flavor moves the gallery to that flavor's photo; the bundle image stays one swipe back. */
    updateBundleImage(initial) {
      if (!this.track) return;
      var slides = this.track.querySelectorAll('[data-bundle-id]');
      if (!slides.length) return;
      var tier = this.querySelector('input[name="jx-tier"]:checked');
      var id = tier ? tier.closest('.jx-tier').dataset.bundleId : '';
      var show = !!id;
      var target = null;
      slides.forEach(function (s) {
        var on = show && s.dataset.bundleId === id;
        s.hidden = !on;
        if (on) target = s;
      });
      var key = target ? id : '';
      if (key === this._bundleKey) return;
      var wasShown = !!this._bundleKey;
      this._bundleKey = key;
      this.bundleOffset = target ? 1 : 0;
      if (target) {
        this.track.scrollTo({ left: 0, behavior: 'auto' });
        this.markActive(-1);
      } else if (wasShown) {
        this.goTo(this.activeIndex >= 0 ? this.activeIndex : 0, false);
      }
    }

    setSubmit(disabled, text, total, stickyLabel) {
      this.submit.disabled = !!disabled;
      this.submitLabel.innerHTML = text;
      if (this.sticky) {
        var price = this.sticky.querySelector('[data-jx-sticky-price]');
        var btn = this.sticky.querySelector('[data-jx-sticky-btn]');
        if (price) price.innerHTML = total != null && !disabled ? this.priceText(total) : '';
        if (btn) btn.disabled = false;
        var lbl = this.sticky.querySelector('[data-jx-sticky-label]');
        if (lbl) lbl.textContent = stickyLabel || (disabled ? this.submit.dataset.soldoutLabel : this.submit.dataset.addLabel);
      }
      reconvertCurrency();
    }

    updateOptionAvailability() {
      var variants = this.data.variants;
      this.querySelectorAll('[data-jx-tier-flavor-select]').forEach(function (select) {
        Array.prototype.forEach.call(select.options, function (opt) {
          var v = variants.find(function (x) { return x.options[0] === opt.value; });
          opt.disabled = !!v && !v.available;
        });
      });

      var sel = this.selectedOptions();
      this.querySelectorAll('[data-jx-option]').forEach(function (group) {
        var idx = Number(group.dataset.jxOption);
        group.querySelectorAll('input[type="radio"]').forEach(function (input) {
          var ok = variants.some(function (v) {
            if (!v.available || v.options[idx] !== input.value) return false;
            return sel.every(function (s, i) { return i === idx || s == null || v.options[i] === s; });
          });
          input.closest('.jx-pill').classList.toggle('is-soldout', !ok);
        });
      });
    }

    syncUrl(id) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* non-critical */ }
    }

    /* ---------- gallery ---------- */
    bindGallery() {
      var self = this, track = this.track;
      if (!track) return;
      var thumbs = this.querySelectorAll('.jx-gal__thumb');
      var dots = this.querySelectorAll('.jx-gal__dots i');

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { self.goTo(Number(t.dataset.thumbIndex), true); });
      });

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)) - self.bundleOffset;
          self.markActive(i);
        });
      }, { passive: true });

      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); self.goTo(self.activeIndex + 1, true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); self.goTo(self.activeIndex - 1, true); }
      });
      this.activeIndex = 0;
      this._thumbs = thumbs;
      this._dots = dots;
    }

    markActive(i) {
      if (i === this.activeIndex) return;
      this.activeIndex = i;
      if (this._thumbs) this._thumbs.forEach(function (t, n) {
        t.classList.toggle('is-active', n === i);
        t.setAttribute('aria-selected', String(n === i));
      });
      if (this._dots) this._dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
    }

    mediaSlides() {
      return this.track ? Array.prototype.filter.call(this.track.children, function (s) { return !s.hasAttribute('data-bundle-id'); }) : [];
    }

    goTo(i, smooth) {
      var slides = this.mediaSlides();
      if (!slides.length) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var behavior = smooth && !reduce ? 'smooth' : 'auto';
      if (i < 0 && this.bundleOffset) { // step back onto the bundle image
        this.track.scrollTo({ left: 0, behavior: behavior });
        this.markActive(-1);
        return;
      }
      i = Math.max(0, Math.min(slides.length - 1, i));
      this.track.scrollTo({ left: slides[i].offsetLeft - this.track.offsetLeft, behavior: behavior });
      this.markActive(i);
    }

    showMedia(mediaId) {
      if (!mediaId || !this.track) return;
      var slides = this.mediaSlides();
      var idx = slides.findIndex(function (s) { return Number(s.dataset.mediaId) === mediaId; });
      if (idx > -1) this.goTo(idx, true);
    }

    /* ---------- sticky add-to-cart (mobile) ---------- */
    bindSticky() {
      var self = this;
      if (!this.sticky) return;
      document.documentElement.classList.add('jx-sticky-atc');
      var btn = this.sticky.querySelector('[data-jx-sticky-btn]');
      if (!btn) return;
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        scrollToBuyBox(self);
      });
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var pastIt = !en.isIntersecting && en.boundingClientRect.top < 0;
          self.sticky.classList.toggle('is-visible', pastIt);
          self.sticky.setAttribute('aria-hidden', String(!pastIt));
          btn.tabIndex = pastIt ? 0 : -1;
        });
      }, { threshold: 0 });
      io.observe(this.submit);
    }
  }

  customElements.define('jx-pdp', JxPdp);
})();

